import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { NewPasswordFields } from "../../../components/NewPasswordFields";
import { useResetPassword } from "../hooks/useResetPassword";

function ResetPassword() {
  const { slug, uid, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [valid, setValid] = useState(false);

  const { mutate, isPending, isSuccess, isError, error } = useResetPassword();

  function handleSubmit(e) {
    e.preventDefault();
    if (!valid) return;
    // Djoser tiene PASSWORD_RESET_CONFIRM_RETYPE=True → exige re_new_password.
    // NewPasswordFields solo marca `valid` cuando ambos campos coinciden, así
    // que reenviar newPassword como re_new_password es correcto.
    mutate({
      uid,
      token,
      new_password: newPassword,
      re_new_password: newPassword,
    });
  }

  if (isSuccess) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center min-vh-100"
        style={{ padding: "1rem" }}
      >
        <Card className="w-100 text-center shadow-sm" style={{ maxWidth: 440 }}>
          <Card.Body className="p-4">
            <h5>Contraseña actualizada</h5>
            <p className="text-muted mt-2">
              Ya puedes iniciar sesión con tu nueva contraseña.
            </p>
            <Link
              to={slug ? `/${slug}/login` : "/login"}
              className="btn btn-primary mt-2"
            >
              Iniciar sesión
            </Link>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  // El backend devuelve el envelope uniforme {code, message, field_errors}. Los
  // errores útiles (contraseña muy común, token inválido) vienen en field_errors
  // o, si no, en message.
  const fieldErrors = error?.response?.data?.field_errors ?? {};
  const errorMsg = isError
    ? Object.values(fieldErrors).flat().join(" ") ||
      error?.response?.data?.message ||
      "El enlace es inválido o expiró. Solicita uno nuevo."
    : null;

  return (
    <Container
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ padding: "1rem" }}
    >
      <Card className="w-100 shadow-sm" style={{ maxWidth: 440 }}>
        <Card.Body className="p-4">
          <h4 className="mb-1">Nueva contraseña</h4>
          <p className="text-muted mb-4">
            Elige una contraseña segura para tu cuenta.
          </p>

          {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

          <Form onSubmit={handleSubmit} noValidate>
            <NewPasswordFields
              value={newPassword}
              onChange={setNewPassword}
              onValidityChange={setValid}
              passwordLabel="Nueva contraseña"
              passwordId="newPassword"
            />

            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={!valid || isPending}
            >
              {isPending ? "Guardando…" : "Cambiar contraseña"}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export { ResetPassword };
